module.exports = __webpack_public_path__ + "static/3-year-old@large-319282ca614828ca1d2beb5ca827cf7a.jpg";